import React from 'react'
import PropTypes from 'prop-types'
import { Copy } from '@elparking/components'
import styled from 'styled-components'
const Link = styled(Copy)`
  cursor: pointer;
  z-index: 9;
`
const MoreInfoLink = ({ openModalInfo }) => {
  const onOpenMoreInfoModal = (e) => {
    e.stopPropagation()
    e.preventDefault()
    openModalInfo()
  }

return <>
    <Link
      onKeyDown={(e) => e.key === 'Enter' && onOpenMoreInfoModal(e)}
      tabIndex={0}
      as='a'
      fontColor='main'
      fontWeight='bold'
      fontSize='xxSmall'
      padding='0 0 0 10px'
      onClick={onOpenMoreInfoModal}
      >{'+info'}</Link>
</>
}
MoreInfoLink.propTypes = {
  openModalInfo: PropTypes.func,
}

export default MoreInfoLink
